import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { getDataPackage } from '../../store/slice'
import { ListReport } from './List'

export const List = () => {
  const data = useSelector(getDataPackage)

  const totalPage = useMemo(() => Math.ceil(data.length / 2), [data.length])
  const [navigate, setNavigate] = useState(1)

  //Actions
  const handleNavigateRight = () => {
    setNavigate((prev) => prev + 1)
  }
  const handleNavigateLeft = () => {
    setNavigate((prev) => prev - 1)
  }
  if (!data.length) {
    return (
      <div className="wh100 dFlex justifyContentCenter alignItemsCenter flex1">
        <Element style={{ color: '#9C9C9C' }}>
          <Translate value="dashboard.currentPlan.noPackage" />
        </Element>
      </div>
    )
  }

  return (
    <div>
      <div className="h100 dFlex positionRelative">
        {navigate > 1 && (
          <div
            className="positionAbsolute"
            style={{
              top: '50%',
              left: 0,
              transform: 'translateY(-50%)',
            }}
          >
            <Element onClick={handleNavigateLeft}>
              <Icon
                className="icon-arrow-circle-left"
                style={{
                  color: '#2C73E8',
                  fontSize: 15,
                }}
              />
            </Element>
          </div>
        )}
        <div
          className="wh100 dFlex alignItemsCenter"
          style={{
            paddingLeft: navigate > 1 ? 24 : 0,
            paddingRight: navigate < totalPage ? 24 : 0,
          }}
        >
          <ListReport page={navigate} data={data} />
        </div>
        {navigate < totalPage && (
          <div
            className="positionAbsolute"
            style={{
              top: '50%',
              right: 0,
              transform: 'translateY(-50%)',
            }}
          >
            <Element onClick={handleNavigateRight}>
              <Icon
                className="icon-arrow-circle-right"
                style={{
                  color: '#2C73E8',
                  fontSize: 15,
                }}
              />
            </Element>
          </div>
        )}
      </div>
    </div>
  )
}
